import { render, staticRenderFns } from "./CustomerBox.vue?vue&type=template&id=5d77ba88"
import script from "./CustomerBox.vue?vue&type=script&lang=js"
export * from "./CustomerBox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports